export const GET_ORDERS_LIST = 'orders/GET_ORDERS_LIST';
export const getOrdersListAction = payload => ({
	type: GET_ORDERS_LIST,
	payload,
});

export const SET_ORDERS_LIST = 'orders/SET_ORDERS_LIST';
export const setOrdersListAction = payload => ({
	type: SET_ORDERS_LIST,
	payload,
});

export const SET_IS_ORDERS_LIST_LOADING = 'orders/SET_IS_ORDERS_LIST_LOADING';
export const setIsOrdersListLoadingAction = payload => ({
	type: SET_IS_ORDERS_LIST_LOADING,
	payload,
});

export const SET_PAGINATION = 'orders/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const GET_MODES = 'orders/GET_MODES';
export const getModesAction = payload => ({
	type: GET_MODES,
	payload,
});

export const SET_MODES = 'orders/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'orders/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const GET_GROUPS = 'orders/GET_GROUPS';
export const getGroupsAction = payload => ({
	type: GET_GROUPS,
	payload,
});

export const SET_GROUPS = 'orders/SET_GROUPS';
export const setGroupsAction = payload => ({
	type: SET_GROUPS,
	payload,
});

export const SET_IS_GROUPS_LOADING = 'orders/SET_IS_GROUPS_LOADING';
export const setIsGroupsLoadingAction = payload => ({
	type: SET_IS_GROUPS_LOADING,
	payload,
});

export const GET_STATUSES = 'orders/GET_STATUSES';
export const getStatusesAction = payload => ({
	type: GET_STATUSES,
	payload,
});

export const SET_STATUSES = 'orders/SET_STATUSES';
export const setStatusesAction = payload => ({
	type: SET_STATUSES,
	payload,
});

export const SET_IS_STATUSES_LOADING = 'orders/SET_IS_STATUSES_LOADING';
export const setIsStatusesLoadingAction = payload => ({
	type: SET_IS_STATUSES_LOADING,
	payload,
});

export const RESET_STATE = 'orders/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const GET_ORDERS_WAYS_LIST = 'orders/GET_ORDERS_WAYS_LIST';
export const getOrdersWaysListAction = payload => ({
	type: GET_ORDERS_WAYS_LIST,
	payload,
});
